import { QueryClient } from "@tanstack/react-query";

export const TSClient = new QueryClient(
    {
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: true,
          retry: 3,
          staleTime: 5 * 60 * 1000,
        }
      }
    }
  )

export const ClearTSCache = () => { 
    TSClient.clear()
}
  